import React from 'react';
import MessageCourier from '../../../lib/MessageCourier';
import SystemClient from '../../../system/SystemClient';
import { PlanillaPartido } from '../../../system/PlanillaPartido/PlanillaPartido';
import PlanillaDigitalForm from '../PlanillaDigitalForm';
import DialogTemplate from '../../Common/DialogTemplate';
import { Icon, TextField } from '@fluentui/react';
import { PlanillaPartidoJugador } from '../../../system/PlanillaPartidoJugador/PlanillaPartidoJugador';
import XhrRequestError from '../../../lib/XhrRequestError';
import { useCustomInput } from '../../../common/custom-hooks/useCustomInput';
import {
  DefaultButton,
  Dropdown,
  IComboBoxOption,
  IDropdownOption,
  Label,
  Text,
  Toggle,
  IconButton,
} from '@fluentui/react';
import { HourSelector } from '../../Common/HourSelector';

interface IDuracionTiemposReglamentariosDialog {
  form: PlanillaDigitalForm;
  system: SystemClient;
  courier: MessageCourier;
  changeBlockUI: (state: boolean) => void;
  isPartidoOnline: boolean;
  showDialog: boolean;
  setShowDialog: (state: boolean) => void;
  startInExtra: boolean;
  setStartInExtra: (state: boolean) => void;
  setTiempoPendienteJuegoEnSegundos: (state: number) => void;
}

const DuracionTiemposReglamentariosDialog = ({
  form,
  system,
  courier,
  changeBlockUI,
  isPartidoOnline,
  showDialog,
  setShowDialog,
  startInExtra,
  setStartInExtra,
  setTiempoPendienteJuegoEnSegundos,
}: IDuracionTiemposReglamentariosDialog) => {
  const [tiempoPendiente, setTiempoPendiente] = React.useState<string>('00:00');

  const onAccept = () => {
    const minutos = +tiempoPendiente.split(':')[0] * 60;
    const segundos = +tiempoPendiente.split(':')[1];
    setTiempoPendienteJuegoEnSegundos(minutos + segundos);
    setShowDialog(false);
  };

  const planillaPartidoInput = useCustomInput(() => form.getPlanillaPartidoInput(), [form]);

  return (
    <DialogTemplate
      showDialog={showDialog}
      toggleShowDialog={() => {
        setShowDialog(!showDialog);
      }}
      title={'Tiempo pendiente de juego'}
      onAccept={() => onAccept()}
      onCancel={() => {}}
      acceptText={'Aceptar'}
      cancelText={'Volver'}
      hideCancelButton
      minWidth={600}
    >
      <div className="ms-Grid" dir="ltr">
        <div className="ms-Grid-row">
          <Label style={{ fontSize: 16 }}>Indica el tiempo total que se debe recuperar.</Label>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm3">
              <Label>Minutos</Label>
            </div>
            <div className="ms-Grid-col ms-sm3">
              <Label>Segundos</Label>
            </div>
            <div className="ms-Grid-col ms-sm6">
              {!planillaPartidoInput.getValue().getPuedeEmpatar() && <Label>Es desde tiempo extra?</Label>}
            </div>
          </div>
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm6">
              <HourSelector
                useLabel={false}
                useHalf
                onChange={(v) => setTiempoPendiente(v)}
                hour={+tiempoPendiente.split(':')[0]}
                minute={+tiempoPendiente.split(':')[1]}
                maxFirstSelector={startInExtra ? 10 : 60}
              ></HourSelector>
            </div>
            <div className="ms-Grid-col ms-sm6">
              {!planillaPartidoInput.getValue().getPuedeEmpatar() && (
                <Toggle
                  checked={startInExtra}
                  onChange={(e, c) => setStartInExtra(!!c)}
                  onText="Si"
                  offText="No"
                ></Toggle>
              )}
            </div>
          </div>
          <div className="ms-Grid-row mt-2">
            <div className="ms-Grid-col ms-sm12">
              <Text variant="medium">
                <Icon iconName="Info" className="text-icon"></Icon>Se calcularán dos periodos en base al
                tiempo pendiente de juego. Por ejemplo si se indica que faltan jugar 20 minutos se jugaran 2
                periodos de 10 minutos
              </Text>
            </div>
          </div>
        </div>
      </div>
    </DialogTemplate>
  );
};

export default DuracionTiemposReglamentariosDialog;
